(function () {
  'use strict';

  angular.module('eclipseApp.core').controller('usageDetailsCtrl', [
    '$scope',
    '$state',
    '$rootScope',
    '$http',
    '$stateParams',
    'uteModal',
    'usageService',
    'uteLocale',
    'commonService',
    'uteEndpoint',
    'lostStolenDeviceService',
    'env',
    'httpService',
    'permissionsService',
    'pricePlanInitiation',
    'dtmService',
    'dtmServiceConstants',
    '$window',
    function ($scope,
              $state,
              $rootScope,
              $http,
              $stateParams,
              uteModal,
              usageService,
              uteLocale,
              commonService,
              uteEndpoint,
              lostStolenDeviceService,
              env,
              httpService,
              permissionsService,
              pricePlanInitiation,
              dtmService,
              dtmServiceConstants,
              $window) {

      // console.log('usageDetails controller init ...');
      // console.log('billingCycleInfo, newCycleStart : ', $scope.billingCycleInfo, $scope.newCycleStart);

      // console.log('ctn, accountNumber: ', $scope.ctn, $scope.ban);
      $scope.showUsageLoader = true;
      $scope.lang = uteLocale.language;
      $scope.disableAllUsage = permissionsService.permissionDetail.isFidoDisableAllUsage;
      $scope.displayDataUsage = permissionsService.permissionDetail.isFidoDisplayDataUsage;
      $scope.refreshFlag = false;

      $scope.brtBasedDisplay = function () {
        var usageTypeVal = $scope.displayDataUsage ? 'Data' : "All" ;
        var refreshedCTN = [];
        if ($window.localStorage.getItem('refreshDataUsage')) {
          refreshedCTN = JSON.parse($window.localStorage.getItem('refreshDataUsage'));
        }
        $scope.refreshFlag = _.indexOf(refreshedCTN, $scope.ctn) > -1 ;
        if ($scope.refreshFlag) {
          usageTypeVal = "All";
          $scope.disableAllUsage = false;
        }
        if (!$scope.disableAllUsage) {
          $http({
            method: 'POST',
            url: uteEndpoint('v1/postpaid/dashboard/usage'),
            //url: '../resource/postpaid-usage.json',
            data: {
              ctn: $scope.ctn,
              language: uteLocale.language,
              accountNumber: $scope.ban,
              usageType: usageTypeVal
            }
          }).success(function (data) {
            $scope.showUsageLoader = false;
            $scope.showUsageColour = true;
            $scope.showUsageColourXsSm = true;
            console.log('data :',data);

            // MCPPC Phase 2 : Proration error messages
            if (data.errorCode != null && data.errorCode != '') {
              $scope.showUsageColour = false;
              $scope.showUsageColourXsSm = false;
              if (data.errorCode == '10012') {
                $scope.prorationError10012 = true;
              } else if (data.errorCode == '10013') {
                $scope.prorationError10013 = true;
              } else {
                $scope.usageError = true;
              }
            } else {
              console.log('data roaming:', data.roaming)
              $scope.usageSuccess = true;
              if (data.roaming.length === 0) {
                $scope.showRoaming = false;
              }
              //$scope.billingCycleInfo = data.billingCycleInfo;
              usageService.getUsageDetails(data, function (_tmp) {
                if (_tmp.result === 'success') {
                  // Proceed to display
                  $scope.wd = _tmp.data;
                  console.log($scope.wd);
                  $scope.displayUsageDetails(_tmp.data);
                }
              });
              $scope.dataIsCollapsed = true;
            }
          }).error(function (data) {
            $scope.showUsageLoader = false;
            $scope.usageError = true;
          });
        }
        else {
          $scope.showUsageLoader = false;
          $scope.showUsageColour = true;
          $scope.showUsageColourXsSm = true;
          $scope.categoryDisabled = ['data','talk','text'];
        }
      };
      $scope.refresh = function () {
        $scope.showUsageLoader = true;
        $scope.disableAllUsage = false;
        $scope.displayDataUsage = false;
        var refreshedCTN = [];
        if ($window.localStorage.getItem('refreshDataUsage')) {
          refreshedCTN = JSON.parse($window.localStorage.getItem('refreshDataUsage'));
        }
        refreshedCTN.push($scope.ctn);
        $window.localStorage.setItem('refreshDataUsage', JSON.stringify(refreshedCTN));
        $scope.brtBasedDisplay();
      };
      $scope.displayUsageDetails = function (allData) {

        // Display main blocks
        var show = false;
        // Process the highest percentage and select proper color as result decide to show in template (show =  true / false)
        show = usageService.globalDataSets(allData.data);
        $scope.showData = show;

        show = usageService.globalDataSets(allData.talk);
        $scope.showTalk = show;

        show = usageService.globalDataSets(allData.text);
        $scope.showSms = show;

        if ($scope.showRoaming) {
          show = usageService.globalDataSets(allData.roaming);
          $scope.showRoaming = show;
        }

      };
      $scope.brtBasedDisplay();
    }

  ]);
})();
